<article *ngIf="paramMap$ | async as paramMap">
	<header class="page-header">
		<h1 translate="process.process"></h1>
	</header>
	<article class="card">
		<div>
			<stages-common-progress
				[operationName]="paramMap.get('jobType')!"
				[jobName]="paramMap.get('jobName')!"
				[workspaceId]="paramMap.get('workspaceId')!"
				[pv]="paramMap.get('processVersion')!"
				[messageKeyPrefix]="getMessageKeyPrefix(paramMap)"
				[stoppable]="paramMap.get('jobType') === 'ADD_MODULE'"
				(closed)="close()"
				(stopped)="stop()"
				(next)="summary()"
			>
			</stages-common-progress>
		</div>
	</article>
</article>
